import { useState } from 'react';

import { DirectUrlScrapingList } from './features/direct-url-scraping/direct-url-scraping.list';
import { GoogleSearchScrapingList } from './features/google-search-scraping/google-search-scraping.list';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/shadcn/tabs';
import { SCRAPING_INTENT_SELECTOR_TYPE } from './types';

export function ScrapingPage() {
  const [activeTab, setActiveTab] = useState<SCRAPING_INTENT_SELECTOR_TYPE>(
    SCRAPING_INTENT_SELECTOR_TYPE.KEYWORD,
  );

  return (
    <div className="flex flex-col gap-4 p-6">
      <Tabs
        value={activeTab}
        onValueChange={(value) => setActiveTab(value as SCRAPING_INTENT_SELECTOR_TYPE)}
        className="gap-4"
      >
        <TabsList>
          <TabsTrigger value={SCRAPING_INTENT_SELECTOR_TYPE.KEYWORD}>Keyword</TabsTrigger>
          <TabsTrigger value={SCRAPING_INTENT_SELECTOR_TYPE.URLS}>URLs</TabsTrigger>
        </TabsList>
        <TabsContent value={SCRAPING_INTENT_SELECTOR_TYPE.KEYWORD}>
          <GoogleSearchScrapingList />
        </TabsContent>
        <TabsContent value={SCRAPING_INTENT_SELECTOR_TYPE.URLS}>
          <DirectUrlScrapingList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
